<script>import NeedReviewIcon from "../../icons/NeedReviewIcon.svelte";
import SuspectIcon from "../../icons/Suspect.svelte";
import ApprovedIcon from "../../icons/Approve.svelte";
import Locked from "../../icons/Locked.svelte";
export let iconName;
export let iconColor;
const getIconComponent = (iconName2) => {
  switch (iconName2) {
    case "NEEDS_REVIEW":
      return NeedReviewIcon;
    case "Suspect":
      return SuspectIcon;
    case "APPROVED":
      return ApprovedIcon;
    case "Locked":
      return Locked;
    default:
      return Locked;
  }
};
const IconComponent = getIconComponent(iconName);
</script>

{#if IconComponent}
	<svelte:component this={IconComponent} iconColor={iconColor} />
{/if}
